import React from 'react'

const formsRoutes = [
    {
        path: '/:siteId/forms/basic',
        component: React.lazy(() => import('./BasicForm')),
    },
    {
        path: '/:siteId/forms/editor',
        component: React.lazy(() => import('./EditorForm')),
    },
    {
        path: '/:siteId/forms/upload',
        component: React.lazy(() => import('./UploadForm')),
    },
    {
        path: '/:siteId/forms/wizard',
        component: React.lazy(() => import('./WizardForm')),
    },
    {
        path: '/:siteId/forms/order-form',
        component: React.lazy(() => import('./order-form/OrderForm')),
    },
    {
        path: '/:siteId/forms/customer-form',
        component: React.lazy(() =>
            import('../pages/customers/customer-form/CustomerForm')
        ),
    },
    {
        path: '/:siteId/forms/invoice-form',
        component: React.lazy(() => import('./invoice-form/InvoiceForm')),
    },
]

export default formsRoutes
